import React from 'react';

import { ReactThreeFiber } from 'react-three-fiber';
import { useTexture } from '../../../hooks';
import { Mesh, Geometry, BufferGeometry, Material } from 'three';

type ImageProps = ReactThreeFiber.Object3DNode<Mesh<Geometry | BufferGeometry, Material | Material[]>, typeof Mesh> & {
  src: string;
  width?: number;
  height?: number;
  position?: ReactThreeFiber.Vector3;
  rotation?: ReactThreeFiber.Euler;
  onClick?: () => void;
};

const Image = ({ src, width = 0.1, height = 0.1, position, rotation, ...props }: ImageProps) => {
  const { texture } = useTexture(src);

  return (
    <mesh position={position} rotation={rotation} {...props}>
      <planeBufferGeometry args={[width, height]} attach="geometry" />
      <meshBasicMaterial attach="material" map={texture} transparent={true} />
    </mesh>
  );
};

export default Image;
